import { RevCard, RevTextArea } from "@revmatics/catalyst";
import { useFormContext } from "react-hook-form";
import { BrandEditByIdBodyType } from "../../../../../../stores/types/brandTypes.tsx";
import { useTrimmedRegister } from "../../../../../../helpers/hooks/useTrimmedRegister.ts";

type Props = {
  readAccessOnly: boolean;
};

export const BrandGuidelinesDosAndDontsView = ({ readAccessOnly }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<BrandEditByIdBodyType>();

  const registerTrimmed = useTrimmedRegister(register);

  return (
    <RevCard
      title="Dos and donts"
      text={
        readAccessOnly
          ? "Who are you, and who are you not? Your brand might have a few sentences, or several pages worth of text."
          : "Who are you, and who are you not? Your brand might have a few sentences, or several pages worth of text. You can copy and paste exisiting text here."
      }
      paddingTitle="py-4 px-6"
      textColor="text-monochrome-900"
      textSize="typography-body-sm"
    >
      <div className="space-y-6">
        <RevTextArea
          name="dos"
          label="Do’s"
          placeholder={readAccessOnly ? "N/A" : "Enter do's"}
          size="md"
          rows={5}
          register={registerTrimmed("dos")}
          error={errors.dos}
          useLength={false}
          disabled={readAccessOnly}
        />
        <RevTextArea
          name="donts"
          label="Dont’s"
          placeholder={readAccessOnly ? "N/A" : "Enter dont's"}
          size="md"
          rows={5}
          register={registerTrimmed("donts")}
          error={errors.donts}
          useLength={false}
          disabled={readAccessOnly}
        />
      </div>
    </RevCard>
  );
};
